import * as THREE from 'three';
import FloatingCards from '../FloatingCards.js';

export default class Camera {
  floatingCards = new FloatingCards()
  sizes = this.floatingCards.sizes
  scene = this.floatingCards.scene
  constructor() {
    this.setup()
  }

  setup() {
    this.instance = new THREE.PerspectiveCamera(45,
      this.sizes.width / this.sizes.height,
      0.1,
      1000)
    this.instance.position.z = 5
    this.scene.add(this.instance)
    this.getFrustumSize()
  }

  resize() {
    this.instance.aspect = this.sizes.width / this.sizes.height
    this.instance.updateProjectionMatrix()
    this.getFrustumSize()
  }

  update() {
    // Update camera
  }

  getFrustumSize() {
    const fov = (this.instance.fov * Math.PI) / 180; // Convert FOV to radians
    const distance = this.instance.position.z; // Distance from camera to z = 0
    this.frustumHeight = 2 * Math.tan(fov / 2) * distance;
    this.frustumWidth = this.frustumHeight * this.instance.aspect; // width = height * aspect ratio
    this.pixelsToSceneUnits = this.frustumWidth / this.sizes.width;
  }
}
